document.addEventListener('alpine:init', () => {
    Alpine.store('flyouts', {
        active: null,
        roomPostId: null,
        roomLoading: false,
        attractionPostId: null,
        attractionLoading: false,

        open(name) {
            this.active = name;
            document.body.classList.add('overflow-hidden');
            requestAnimationFrame(() => {
                const flyout = document.querySelector(`[data-flyout="${name}"]`);
                if (flyout) flyoutFocusable(flyout)[0]?.focus();
            });
        },

        close() {
            this.active = null;
            this.roomPostId = null;
            this.attractionPostId = null;
            document.body.classList.remove('overflow-hidden');
        },

        toggle(name) {
            if (this.active === name) {
                this.close();
            } else {
                this.open(name);
            }
        },

        isOpen(name) {
            return this.active === name;
        },

        openRoom(postId) {
            flyoutTrigger = document.activeElement !== document.body ? document.activeElement : null;
            this.roomPostId = postId;
        },

        openAttraction(postId) {
            flyoutTrigger = document.activeElement !== document.body ? document.activeElement : null;
            this.attractionPostId = postId;
        },
    });
});

let flyoutTrigger = null;

function flyoutFocusable(flyout) {
    return [...flyout.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )].filter(el => el.offsetParent !== null);
}

document.addEventListener('click', (e) => {
    const toggleBtn = e.target.closest('[data-flyout-toggle]');
    if (toggleBtn) {
        e.preventDefault();
        const name = toggleBtn.dataset.flyoutToggle;
        Alpine.store('flyouts').toggle(name);

        if (Alpine.store('flyouts').isOpen(name)) {
            flyoutTrigger = toggleBtn;
        } else {
            flyoutTrigger = null;
        }
        return;
    }

    if (e.target.closest('[data-flyout-close]')) {
        Alpine.store('flyouts').close();
        flyoutTrigger?.focus();
        flyoutTrigger = null;
    }
});

window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
        const escEvent = new CustomEvent('flyout:escape', { cancelable: true, bubbles: true });
        (document.activeElement || document.body).dispatchEvent(escEvent);
        if (!escEvent.defaultPrevented) {
            Alpine.store('flyouts').close();
            flyoutTrigger?.focus();
            flyoutTrigger = null;
        }
        return;
    }

    if (e.key === 'Tab') {
        const name = Alpine.store('flyouts').active;
        const flyout = name ? document.querySelector(`[data-flyout="${name}"]`) : null;
        if (!flyout) return;

        const focusable = flyoutFocusable(flyout);
        if (!focusable.length) {
            e.preventDefault();
            Alpine.store('flyouts').close();
            flyoutTrigger?.focus();
            flyoutTrigger = null;
            return;
        }

        if (!flyoutTrigger) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            Alpine.store('flyouts').close();
            flyoutTrigger.focus();
            flyoutTrigger = null;
        } else if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            Alpine.store('flyouts').close();
            flyoutTrigger.focus();
            flyoutTrigger = null;
        }
    }
}, true);

document.addEventListener('gform_confirmation_loaded', function (event) {
    const message = document.querySelector('.gform_confirmation_message');
    const content = document.getElementById('flyout-confirmation-content');
    if (!message || !content) return;

    content.innerHTML = message.innerHTML;
    Alpine.store('flyouts').close();
    Alpine.store('flyouts').open('confirmation');
});

document.addEventListener('alpine:init', () => {
    if (new URLSearchParams(window.location.search).get('ref') === 'lillaradmannen') {
        if (!document.cookie.split(';').some(c => c.trim() === 'ref_lillaradmannen=true')) {
            document.cookie = 'ref_lillaradmannen=true; path=/; max-age=' + (60 * 60 * 24 * 365);
            setTimeout(() => Alpine.store('flyouts').open('info'), 800);
        }
    }
});

//# sourceMappingURL=flyout.js.map
